// Насколько число отличается от прошлого периода — метка рядом с крупной суммой.
//
// ## Почему метки может не быть вовсе
//
// Правило 7: пустое, нулевое и неизвестное выглядят по-разному. Здесь это буквально:
//
//   * прошлого периода в данных нет — метки НЕТ. «0%» означало бы «не изменилось», а правда
//     другая: не с чем сравнивать. По разнице между этими двумя фактами принимают разные
//     решения;
//   * в прошлом периоде был ноль — метки тоже нет. Рост с нуля в процентах не выражается, а
//     «+∞%» или «+100%» — это выдуманное число;
//   * ноль разницы — метка есть и говорит словами «как в прошлом месяце». Это факт, и его
//     стоит сказать: человек, увидевший цифру без метки, будет искать, где же сравнение.
//
// ## Почему смысл задаёт вызывающий
//
// Рост расхода — плохо. Рост возвратов в кассу — хорошо. Рост суммы к выплате людям — просто
// факт. Одно и то же направление красится по-разному, и знать об этом может только тот, кто
// знает, о чём число.

export interface МеткаДельты {
  text: string;
  tone: 'плохо' | 'хорошо' | 'ровно';
}

export function дельтаКПрошлому(
  стало: number,
  было: number | null | undefined,
  плохоЕсли: 'рост' | 'падение' = 'рост',
): МеткаДельты | undefined {
  if (было === null || было === undefined || было === 0) {
    return undefined;
  }
  const процент = Math.round(((стало - было) / Math.abs(было)) * 100);
  if (процент === 0) {
    return { text: 'как в прошлом месяце', tone: 'ровно' };
  }
  const вырос = процент > 0;
  return {
    text: `${вырос ? '+' : '−'}${Math.abs(процент)}% к прошлому месяцу`,
    tone: вырос === (плохоЕсли === 'рост') ? 'плохо' : 'хорошо',
  };
}
